export const Repeat = ({ numberOfTimes, children }) => {
  let items = [];
  for (let i = 0; i < numberOfTimes; i++) {
    items.push(children(i));
  }
  return <>{items}</>;
};
